import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

const initialState = {
  collectionLikeCount: null,
  togetherLikeCount: null,
  cellCreateCount: null,
  collectionPurchaseCount: null,
  eventParticipantCount: null,
};

const SET_COUNTS = 'jisikTrip/SET_COUNTS';

export const setCounts = createAction(SET_COUNTS);

export default handleActions(
  {
    [SET_COUNTS]: (state, action) =>
      produce(state, (draft) => {
        Object.assign(draft, action.payload);
      }),
  },
  initialState,
);